import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/personal-loan", label: "Personal Loan" },
  { to: "/identity-protection", label: "Credit Health" },
  { to: "/credit-builder", label: "Credit Builder" },
  { to: "/how-it-works", label: "How It Works" },
];

const linkClass = ({ isActive }) =>
  `text-[11px] lg:text-xs uppercase tracking-[0.15em] lg:tracking-[0.2em] transition-colors duration-300 ${
    isActive ? "text-[#0C6B4F]" : "text-[#5C6B62] hover:text-[#0F1F1A]"
  }`;

export default function SiteNav() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-2xl bg-white/70 border-b border-black/10" data-testid="site-nav">
      <nav className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="font-display text-xl md:text-2xl tracking-tight text-[#0F1F1A]">
          Trusted <span className="italic text-[#0C6B4F]">Financial Hub</span>
        </Link>
        <div className="hidden md:flex items-center gap-6 lg:gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} className={linkClass}>
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="hidden md:block">
          <Link
            to="/#apply"
            data-testid="nav-cta-button"
            className="inline-block bg-[#0C6B4F] text-white text-xs font-semibold uppercase tracking-[0.15em] px-5 py-2.5 rounded-full hover:bg-[#0A5C43] active:scale-[0.98] transition-[background-color,transform] duration-300"
          >
            Get Started
          </Link>
        </div>
        <button className="md:hidden text-[#0F1F1A]" data-testid="nav-menu-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden overflow-hidden backdrop-blur-2xl bg-white/90 border-b border-black/10"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)} className={linkClass}>
                  {l.label}
                </NavLink>
              ))}
              <Link
                to="/#apply"
                onClick={() => setOpen(false)}
                data-testid="mobile-nav-cta"
                className="mt-2 inline-block text-center bg-[#0C6B4F] text-white text-xs font-semibold uppercase tracking-[0.15em] px-5 py-3 rounded-full"
              >
                Get Started
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
